package com.macrofocus.trenddisplay.timeseriesplot

import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotConfiguration.MarkerType
import org.mkui.geom.GeneralPath
import org.mkui.geom.Rectangle2D
import org.mkui.geom.Shape
import org.mkui.geom.curve.*
import org.mkui.graphics.IGraphics
import org.mkui.transform.TwoDScreenTransform
import org.molap.series.TimeSeries

class CardinalSplineTimeSeriesRenderer : TimeSeriesPlotRenderer {
    override fun getShape(
        timeSeries: TimeSeries<Int,*>?,
        screenTransform: TwoDScreenTransform,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration,
    ): Pair<Shape,Shape> {
        val markerPath: GeneralPath = GeneralPath()
        val linePath: ShapeMultiPath = ShapeMultiPath(2)

        val isNumerical = true
        if (isNumerical) {
            if (timeSeries != null) {
                val curves: ControlPath = ControlPath()

                var previous: RangePoint? = null

                var cp: ControlPath? = null

                for (i in timeSeries.keys()!!) {
                    val x: Int = screenTransform.xWorldToScreen(timeSeries.getTime(mode, i).toDouble())
                    val yValue: Any? = timeSeries.get(i)
                    if (yValue != null) {
                        val y: Int = screenTransform.yWorldToScreen((yValue as Number).toDouble())

                        if (cp != null) {
                            if (previous != null) {
                                cp.addPoint(createPoint2(x.toDouble(), y.toDouble()))
                            } else {
                                println("Error")
                            }
                        } else {
                            cp = ControlPath()
                            cp.addPoint(createPoint2(x.toDouble(), y.toDouble()))
                            cp.addPoint(createPoint2(x.toDouble(), y.toDouble()))
                        }

                        if (previous != null) {
                            previous.setValue(x, y)
                        } else {
                            previous = RangePoint()
                            previous.setValue(x, y)
                        }

                        //                        if (previous != null) {
//                            if (x != previous.x) {
//                                if (previous.yMin != previous.yMax) {
//                                    if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
//                                        linePath.lineTo(previous.x, previous.yMin);
//                                        linePath.lineTo(previous.x, previous.yMax);
//                                        linePath.lineTo(previous.x, previous.y);
//                                    }
//                                }
//                                if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
//                                    if (configuration.getLineType() == TimeSeriesPlotConfiguration.LineType.Step) {
//                                        linePath.lineTo(x, previous.y);
//                                    }
//                                    linePath.lineTo(x, y);
//                                }
//                            }
//                            previous.setValue(x, y);
//                        } else {
//                            previous = new RangePoint();
//                            previous.setValue(x, y);
//                            linePath.moveTo(x, y);
//                            linePath.lineTo(x, y);
//                        }
                        if (configuration.getMarkerType() != MarkerType.None) {
                            val size = configuration.getMarkerSize().toDouble()
                            val halfSize = size / 2.0
                            val shape: Shape = Rectangle2D.Double(x - halfSize, y - halfSize, size, size)
                            markerPath.append(shape.getPathIterator(), false)
                        }
                    } else {
                        if (cp != null) {
                            cp.addPoint(createPoint2(x.toDouble(), previous!!.y.toDouble()))
                            val cardinalSpline: CatmullRomSpline = CatmullRomSpline(
                                cp, GroupIterator(
                                    intArrayOf(0, cp.numPoints() - 1)
                                )
                            )
                            curves.addCurve(cardinalSpline)
                        }
                        cp = null

                        previous = null
                    }
                }

                if (cp != null) {
                    cp.addPoint(createPoint2(previous!!.x.toDouble(), previous.y.toDouble()))

                    val cardinalSpline: CatmullRomSpline = CatmullRomSpline(
                        cp, GroupIterator(
                            intArrayOf(0, cp.numPoints() - 1)
                        )
                    )
                    //            cardinalSpline.setAlpha(0.5);
                    curves.addCurve(cardinalSpline)
                }

                val dimension = 2
                val mp: ShapeMultiPath = ShapeMultiPath(dimension)
                mp.flatness = 1.0 // default flatness is 1.0

                for (i in 0..<curves.numCurves()) {
                    val curve: Curve = curves.getCurve(i)
                    curve.appendTo(mp)
                }
            }
        } else {
//            final TimeSeriesVariable timeSeriesVariable = (TimeSeriesVariable) variable;
//            final TimeSeries timeSeries = (TimeSeries) timeSeriesVariable.getValue(dataset, plot.getSubject());

            if (timeSeries != null) {
//                g2.setColor(configuration.getMarkerColor())

                if (configuration.getMarkerType() == MarkerType.VerticalLine) {
//                    g2.setStroke(new BasicStroke(configuration.getMarkerSize()));
                }
                if (configuration.getDisplayValue()) {
//                    final Font font = g2.getFont().deriveFont(10.0f * configuration.getMarkerSize());
//                    g2.setFont(font);
                }

                if (configuration.getMarkerType() != MarkerType.None || configuration.getDisplayValue()) {
//                    val textY: Int = g2.getFontMetrics()!!.getAscent()
                    for (i in 0..<timeSeries.size()) {
//                        final int x = plot.worldToScreenX(timeSeries.getTime(i));
                        val value: Any? = timeSeries.get(i)

                        if (value != null) {
                            when (configuration.getMarkerType()) {
                                MarkerType.VerticalLine -> {}
                                MarkerType.Point -> {
                                    val size = configuration.getMarkerSize()
                                    val halfSize = size / 2.0f
                                }
                                MarkerType.None -> {}
                            }
                            if (configuration.getDisplayValue()) {
                                when (configuration.getMarkerType()) {
                                    MarkerType.None, MarkerType.VerticalLine -> {}
                                    MarkerType.Point -> {}
                                }
                            }
                        }
                    }
                }
            }
        }

        return Pair(markerPath, linePath)
    }

    override fun draw(
        timeSeries: TimeSeries<Int,*>?,
        screenTransform: TwoDScreenTransform,
        g2: IGraphics,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration,
        probed: Boolean,
        selected: Boolean
    ) {
//        final CPColor oldColour = g2.getColor();
//        final Stroke oldStroke = g2.getStroke();
//        final Font oldFont = g2.getFont();

        val (markerPath, linePath) = getShape(timeSeries, screenTransform, mode, configuration)

//        g2.setStroke(new BasicStroke(configuration.getLineWidth()));
//        AffineTransform oldTransform = (AffineTransform) g2.getTransform().clone();
//        AffineTransform transform = g2.getTransform();
//        transform.translate(-1.0, 1.0);
//        g2.setTransform(transform);
//        g2.setColor(new Color(180, 180, 180));
//        g2.draw(linePath);
//        g2.setTransform(oldTransform);
        g2.setColor(configuration.getLineColor())
        g2.pickDraw(linePath, null, null, null)

        g2.setColor(configuration.getMarkerColor())
        g2.pickDraw(markerPath, null, null, null)

//        g2.setColor(oldColour);
//        g2.setStroke(oldStroke);
//        g2.setFont(oldFont);
    }

    private inner class RangePoint {
        var x: Int = 0
        var y: Int = 0
        var yMin: Int = 0
        var yMax: Int = 0

        fun setValue(x: Int, y: Int) {
            if (this.x == x) {
                if (y < yMin) {
                    yMin = y
                }
                if (y > yMax) {
                    yMax = y
                }
                this.y = y
            } else {
                this.x = x
                this.y = y
                this.yMin = y
                this.yMax = y
            }
        }
    }

    companion object {
        private fun createPoint(x: Double, y: Double): Point {
            val location = doubleArrayOf(x, y)
            return object : Point {
                override val location: DoubleArray
                    get() = location
            }
        }

        private fun createPoint2(x: Double, y: Double): Point {
            val location = doubleArrayOf(x, y)
            return object : Point {
                override val location: DoubleArray
                    get() = location
            }
        }
    }
}
